// Identifies this specific browser tab so the backend can tell an accepting
// tab's own websocket connection apart from the same agent's other open tabs
// when broadcasting voice_call.accepted (see actionCable.js#onVoiceCallAccepted).
// sessionStorage (not localStorage) is per-tab by design, so a duplicated tab
// still gets a fresh id rather than inheriting the source tab's.
const STORAGE_KEY = 'chatwoot_call_tab_id';

const generateId = () =>
  window.crypto?.randomUUID?.() ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const getOrCreateTabId = () => {
  let id = window.sessionStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = generateId();
    window.sessionStorage.setItem(STORAGE_KEY, id);
  }
  return id;
};

export const CALL_TAB_ID = getOrCreateTabId();
